import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// components
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { addBreadcrumbSchema } from '../helpers';
// hooks
import { useWindowSize } from '../../Hooks/use-window-size';
// settings
import { partners } from './settings';

const BarometerPage = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');

  useEffect(() => {
    const metaTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaTitle) {
      metaTitle.textContent = 'Барометр ринку праці 2024 | GRC.UA';
    }

    if (metaDescription) {
      metaDescription.content = 'Барометр ринку праці — це системне дослідження, яке компанія GRC.UA проводить вже 13 років поспіль, поширюючи аналітичні матеріали серед бізнес-спільноти та ЗМІ. GRC.UA – українська компанія, що володіє кадровим порталом, єдиним в Україні створеним професіоналами з підбору та управління персоналом та поєднує онлайн-можливості порталу з пошуку роботи та офлайн-агенцію з підбору персоналу.'; // eslint-disable-line
    }

    window.scrollTo(0, 0);

    const breadcrumbs = [
      { name: 'Барометр ринку праці' },
    ];

    const script = addBreadcrumbSchema(breadcrumbs);

    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [t]);

  return (
    <>
      <NavBar />
      <div className='mb-5 barometerPage'>
        <section className='hero'>
          <h6 className='container text-muted fw-normal'>
            <Link to='/' style={{ color: 'grey' }}>
              {t('navHeaders.home')}
            </Link>
            {' / '}
            Барометр ринку праці
          </h6>
          <div className='container'>
            <h1>
              Барометр ринку праці 2024 Прогнози на 2025
            </h1>
          </div>
        </section>
        <section id='aboutProject' className='aboutProject'>
          <div className='container standartListStyle'>
            <h2>
              Про проєкт «Барометр ринку праці»
            </h2>
            <p className='mb-3'>
              <span className='boldSpan'>Барометр ринку праці</span> —  це системне дослідження, яке компанія
              <span className='redSpan'> GRC.UA </span> проводить вже <span className='boldSpan'>13 років поспіль</span>
              , поширюючи аналітичні матеріали серед бізнес-спільноти та ЗМІ.
            </p>
            <p className='mb-4'>
              Щороку презентація результатів Барометру збирає лідерів думок, представників державних інституцій і бізнесу, HR-експертів
              України та представників ЗМІ для обговорення найактуальніших питань ринку праці та формування прогнозів на наступний рік.
            </p>
            <p className='mb-3'>
              <span className='boldSpan'>Питання, що будуть висвітлюватися:</span>
            </p>
            <ul className='mb-4'>
              <li>факт і плани найму компаній 2024-2025;</li>
              <li>збільшення/зменшення зарплат;</li>
              <li>збільшення/зменшення бонусів;</li>
              <li>
                робота з ветеранами, кандидатами 50+, молоддю, нові «жіночі» професії, програми залучення мігрантів, питання інклюзивності та безбар’єрності;
              </li>
              <li>well-being програми в компаніях — створення інклюзивних робочих місць, релокація бізнесів та персоналу;</li>
              <li>основні виклики в роботі з персоналом на 2025 рік та найближчі 3 роки, та ін.</li>
            </ul>
            <p className='mb-3'>
              Організатор дослідження —<span className='redSpan'> GRC.UA </span>у партнерстві з <span className='boldSpan'>Альоною Кавкою, HRD KNESS, </span>
              media_hr_expert
            </p>
            <p className='mb-5'>
              Методологія дослідження —<span className='redSpan'> GRC.UA</span>
            </p>
            <Link to='/anketa' className='mb-5'>
              <button className='button1'>
                Пройти опитування
              </button>
            </Link>
            <p className='mb-3'>
              <span className='boldSpan'>Читайте також:</span>
            </p>
            <a
              target='_blank'
              href='https://barometr.grc.ua/'
              rel='noreferrer noopener nofollow'
            >
              <div className='linkBox'>
                <p>
                  https://barometr.grc.ua/
                </p>
                <p>
                  <span className='redSpan'>Барометр ринку праці України 2023. Прогнози на 2024</span>
                </p>
              </div>
            </a>
          </div>
        </section>
        <section className='timingSection'>
          <div className='container standartListStyle'>
            <h2>
              Таймінг проєкту «Барометр ринку праці»
            </h2>
            {
              width < 992
                ? (
                  <div className='timingBox standartListStyle'>
                    <img width={36} height={795} src='/Images/barometer/timeline.png' />
                    <div className='timingMobile'>
                      <div className='firstStage'>
                        <p><span className='boldSpan'>Липень 2024</span></p>
                        <p className='mb-2'>Підготовчий етап проведення дослідження «Барометр ринку праці»</p>
                        <ul>
                          <li className='mb-2'>Залучення Партнерів</li>
                          <li className='mb-2'>Підготовка опитувальників</li>
                          <li>Підготовка рекламно-інформаційної кампанії</li>
                        </ul>
                      </div>
                      <div className='secondStage'>
                        <p><span className='boldSpan'>1 вересня — 18 листопада 2024</span></p>
                        <p className='mb-2'>Старт дослідження</p>
                        <ul>
                          <li className='mb-2'>Опитування та збір даних ЦА Роботодавці</li>
                          <li className='mb-2'>Опитування та збір даних ЦА Шукачі</li>
                          <li>Залучення респондентів</li>
                        </ul>
                      </div>
                      <div className='thirdStage'>
                        <p><span className='boldSpan'>1 листопада — 18 листопада 2024</span></p>
                        <p>Підготовка коментарів до аналітики Барометра. Залучення галузевих експертів</p>
                      </div>
                      <div className='fourthStage'>
                        <p><span className='boldSpan'>18 листопада — 10 грудня 2024</span></p>
                        <p>Підготовка аналітичного звіту за підсумками дослідження. «Барометр ринку праці 2023»</p>
                      </div>
                      <div className='fifthStage'>
                        <p><span className='boldSpan'>11 грудня 2024</span></p>
                        <p>Підведення підсумків Барометра ринку праці <span>Прес-конференція. Офіційний пост-реліз Барометра.</span></p>
                      </div>
                    </div>
                  </div>
                )
                : (
                  <div className='timingBox standartListStyle'>
                    <div className='periodBox'>
                      <p className='firstDate'>Липень 2024</p>
                      <p className='secondDate'>1 вересня — <br /> 18 листопада 2024</p>
                      <p className='thirdDate'>1 листопада — <br />18 листопада 2024</p>
                      <p className='fourthDate'>18 листопада —  <br />10 грудня 2024</p>
                      <p className='fifthDate'>11 грудня 2024</p>
                    </div>
                    <div className='stageDescrBox'>
                      <div className='firstStage'>
                        <p className='mb-3'>Підготовчий етап проведення дослідження «Барометр ринку праці»</p>
                        <ul>
                          <li className='mb-3'>Залучення Партнерів</li>
                          <li className='mb-3'>Підготовка опитувальників</li>
                          <li>Підготовка рекламно-інформаційної кампанії</li>
                        </ul>
                      </div>
                      <div className='secondStage'>
                        <p className='mb-3'>Старт дослідження</p>
                        <ul>
                          <li className='mb-3'>Опитування та збір даних ЦА Роботодавці</li>
                          <li className='mb-3'>Опитування та збір даних ЦА Шукачі</li>
                          <li>Залучення респондентів</li>
                        </ul>
                      </div>
                      <p className='thirdStage'>Підготовка коментарів до аналітики Барометра. Залучення<br />галузевих експертів</p>
                      <p className='fourthStage'>Підготовка аналітичного звіту за підсумками дослідження.<br />«Барометр ринку праці 2023»</p>
                      <p className='fifthStage'>
                        Підведення підсумків Барометра ринку праці<br /><span>Прес-конференція. Офіційний пост-реліз Барометра.</span>
                      </p>
                    </div>
                  </div>
                )
            }
          </div>
        </section>
        <section id='partnersSection' className='partnersSection'>
          <div className='container'>
            <h2>
              Партнери проєкту «Барометр ринку праці»
            </h2>
            <div className='generalPartnerBox'>
              <div className='partnersCard'>
                <img width={233} alt='mhp-logo' src='/Images/barometer/mhp-logo.png' />
                <h3>
                  Генеральний партнер
                </h3>
                <p className='mb-3'>
                  МХП — міжнародна компанія у сфері харчових та агротехнологій. Об&apos;єднує понад 32 тисячі працівників в Україні та за кордоном, входить
                  до 10 кращих роботодавців України за версією Forbes.
                </p>
                <p className='mb-3'>
                  МХП експортує продукцію в понад 70 країн світу, розвиває понад 15 продуктових брендів. Має виробничі потужності в Україні та на Балканах.
                </p>
                <p className='mb-3'>
                  Компанія є найбільшим платником податків у агросекторі за 2023 рік, входить в ТОП-5 найбільших інвесторів країни.
                </p>
                <p>
                  Спільно зі стратегічним партнером Благодійним фондом «МХП – Громаді» компанія розвиває громади. Для індивідуального супроводу та комплексної
                  підтримки військових, ветеранів, їхніх родин та тих, хто чекає близьких з фронту, реалізує програму «МХП Поруч».
                </p>
              </div>
            </div>
            <div className='partnersBox standartListStyle'>
              {
                partners.map(({ logo, title, text1, text2, text3, width }) => (
                  <div key={logo} className='partnersCard'>
                    <img width={width} alt='partner-logo' src={logo} />
                    <h3>{title}</h3>
                    <p className='mb-3'>{text1}</p>
                    <p className='mb-3'>{text2}</p>
                    <p>{text3}</p>
                  </div>
                ))
              }
              <div className='partnersCard'>
                <img width={190} alt='partner-logo' src='/Images/barometer/sat-logo.jpg' />
                <h3>Експертний галузевий партнер</h3>
                <p className='mb-3'>
                  Транспортна компанія SAT – один із лідерів у сфері вантажоперевезень України.
                </p>
                <p className='mb-3'>Ми пропонуємо комплексні логістичні рішення, що ідеально налаштовані під потреби бізнесу.</p>
                <p className='mb-3'>
                  Для ще більшої зручності наших клієнтів, ми розробили Особистий Кабінет для керування відправленнями та підтримуємо комунікацію
                  через зручних ботів. Наша мета – це максимальна ефективність, якість та надійність.
                </p>
                <p>SAT – це логістика, що працює для вашого успіху!</p>
              </div>
              <div className='partnersCard'>
                <img width={100} alt='partner-logo' src='/Images/barometer/delo-logo.png' />
                <h3>Інформаційний партнер</h3>
                <p className='mb-3'>
                  <a href='https://delo.ua/' className='me-3' target='_blank' rel='noreferrer nofollow noopener'>delo.ua</a>
                  – один із провідних ділових порталів України, що докладно висвітлює актуальні теми бізнесу, політики та економіки країни.
                </p>
                <p className='mb-3'>Входить в топ-3 бізнес видань, яким найбільше довіряють топ-менеджери та власники бізнесу в Україні.</p>
                <p>
                  За 2023 рік delo.ua зібрав рекордні 46,9 млн. відвідувань, більше двох мільйонів унікальних користувачів, а за даними Google
                  Analytics за 2023 рік аудиторія порталу сягнула 60 млн.
                </p>
              </div>
              <div className='partnersCard'>
                <img width={100} alt='partner-logo' src='/Images/barometer/hurma-logo.png' />
                <h3>Інформаційний партнер</h3>
                <p className='mb-3'>
                  HURMA це не просто автоматизації рекрутингу та HR – це екосистема, яка допомагає, підтримує ініціативи та надихає розвиватись у вашій сфері!
                </p>
                <p className='mb-3'>З HURMA ви матимете доступ до безлічі корисних та потрібних речей, які завжди під рукою:</p>
                <ul className='mb-3'>
                  <li>автоматизація рутиних задач рекрутерів та HR</li>
                  <li>профeсійне комʼюніті з безкоштовними менторськими сесіями</li>
                  <li>величезна база знань з матеріалами та вебінарами</li>
                  <li>якісна профільна освіта від кращих фахівців</li>
                  <li>майже цілодобова підтримка, поради колег та експертів</li>
                </ul>
                <p className='mb-3'>Станьте частиною екосистеми HURMA!</p>
                <p>
                  Детальніше:
                  <a href='https://t.me/HurmaCommunity_bot?start=66faec9fe2c952cd160184f5' className='ms-2' target='_blank' rel='noreferrer nofollow noopener'>
                    <i className='fa-brands fa-telegram' /> HURMA Community Info
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id='aboutSection' className='aboutSection'>
          <div className='container'>
            <h2>
              Про компанію GRC.UA
            </h2>
            <p className='mb-3'>
              <span className='redSpan'>GRC.UA</span> – українська компанія, що володіє кадровим порталом, єдиним в Україні створеним професіоналами
              з підбору та управління персоналом та поєднує онлайн-можливості порталу з пошуку роботи та офлайн-агенцію з підбору персоналу.
            </p>
            <p className='mb-3'>
              Входить до найбільшого міжнародного альянсу <span className='boldSpan'>Kestria</span>, що надає можливість пошуку персоналу
              більше ніж в <span className='boldSpan'>47 країнах</span> світу.
            </p>
            <p className='mb-3'>
              Організатор подій для HR-спільноти <span className='boldSpan'>«HRD-середа», «Рекруторія», «Барометр ринку праці», </span>
              центр знань та комунікацій з питань репутації роботодавця, популяризації бренду роботодавця та job-маркетингу.
            </p>
            <p>
              На <span className='redSpan'>GRC.UA</span> розміщують резюме та знаходять роботу професіонали та перспективні спеціалісти всіх рівнів.
            </p>
          </div>
        </section>
        <section className='invitationSection'>
          <div className='container invitationBox'>
            <div className='invitationDescr'>
              <h2>
                Запрошуємо взяти участь в дослідженні «Барометр ринку праці 2024-2025 від GRC.UA»
              </h2>
              <p className='mb-3 highlighted'>Ваша участь – наша вдячність:</p>
              <p className='mb-5'>
                Після завершення дослідження ми поділимося з вами його результатами та запросимо вас на онлайн-презентацію, під час якої
                обговоримо ключові тренди та рекомендації для бізнесу і працівників.
              </p>
              <Link to='/anketa'>
                <button className='button1'>
                  Пройти опитування
                </button>
              </Link>
            </div>
            <img width={543} alt='invitation-image' src='/Images/barometer/invitation.png' />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default BarometerPage;
